@if (optimData && optimData.correlation_matrix) {
  <div
    class="card-sub-title"
    (click)="!isPrint ? (section_expanded = !section_expanded) : null"
    style="
      cursor: pointer;
      font-size: 13px;
      font-weight: 600;
      color: var(--text-dim);
      margin-bottom: 12px;
    "
  >
    {{ matrixDataType === "correlation" ? "Correlation" : "Covariance" }} Matrix
  </div>
  <div
    class="expanding-content"
    [@detailExpand]="section_expanded ? 'expanded' : 'collapsed'"
  >
    @if (!isPrint) {
      <div class="row mb-3">
        <div class="col">
          <mat-form-field class="w-100" appearance="outline">
            <mat-label>Chart Data</mat-label>
            <mat-select [(ngModel)]="matrixDataType" name="matrix-data-type">
              <mat-option [value]="'covariance'">Covariance Matrix</mat-option>
              <mat-option [value]="'correlation'"
                >Correlation Matrix</mat-option
              >
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Frequency Data</mat-label>
            <mat-select
              [(ngModel)]="optimData.optim_parameters.correlation_frequency"
            >
              @for (
                o of optimData.correlation_matrix.params.frequencies;
                track o
              ) {
                <mat-option [value]="o.id">
                  {{ o.name }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Method</mat-label>
            <mat-select
              [(ngModel)]="optimData.optim_parameters.correlation_method"
            >
              @for (o of optimData.correlation_matrix.params.methods; track o.id) {
                <mat-option [value]="o.id">
                  {{ o.name }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        @if (
          optimData.optim_parameters.correlation_method ==
            "exponential_decay" && optimData.optim_parameters
        ) {
          <div class="col">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Covariance Matrix λ</mat-label>
              <input
                matInput
                [(ngModel)]="optimData.optim_parameters.covmat_lambda"
                type="number"
              />
            </mat-form-field>
          </div>
        }
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Shock Diagonals</mat-label>
            <input
              matInput
              value="0"
              type="number"
              min="0"
              max="100"
              [(ngModel)]="
                optimData.optim_parameters.correlation_shock_diagonal
              "
            />
            <span matSuffix>%</span>
          </mat-form-field>
        </div>
      </div>
    }
    <div [class.col-md-12]="isPrint">
      @if (correlationMatrixTableData && matrixDataType == "correlation") {
        <app-heatmap-table
          [dataRaw]="correlationMatrixTableData"
          [allowedTickers]="allowedTickers"
          [divergent]="true"
        ></app-heatmap-table>
      }
      @if (covarianceMatrixTableData && matrixDataType == "covariance") {
        <app-heatmap-table
          [dataRaw]="covarianceMatrixTableData"
          [allowedTickers]="allowedTickers"
        ></app-heatmap-table>
      }
    </div>
  </div>
}
